import { defaultMeta } from '../routesSetup';
import RequestIsForView from '../../lib/pages/RequestIsForView.vue';
import YourDetailsView from '../../lib/pages/YourDetailsView.vue';
import PatientDetailsView from '../../lib/pages/PatientDetailsView.vue';
import ProblemDetailsView from '../../lib/pages/ProblemDetailsView.vue';
import SummaryView from '../../lib/pages/SummaryView.vue';
import SubmittedSuccessfullyView from '../../lib/pages/SubmittedSuccessfullyView.vue';
import {
  formAdminRequestDetails,
  formPatientDetailsYou,
  formReporterType,
  formYourDetails,
} from '../../data/forms';
import { DefaultLayout } from '../../lib/layouts/layouts';
import { RouteRecordRaw } from 'vue-router';
import MedicalWarningView from '../../lib/pages/MedicalWarningView.vue';
const defaultMetaMedicalRequest = { ...defaultMeta, requiresLoadedTenant: true };

const adminRequestChildren: RouteRecordRaw[] = [
  {
    path: 'medical-warning',
    name: 'medical-warning-ar',
    component: MedicalWarningView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: "Check it's not an emergency",
      pageTitle: "Check it's not an emergency",
    },
  },
  {
    path: 'request-is-for',
    name: 'admin-request-is-for',
    component: RequestIsForView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formReporterType,
      layoutComponent: DefaultLayout,
      layoutPageTitle: null,
    },
  },
  {
    path: 'your-details',
    name: 'admin-your-details',
    component: YourDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formYourDetails,
    },
  },
  {
    path: 'patient-details',
    name: 'admin-patient-details',
    component: PatientDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formPatientDetailsYou,
    },
  },
  // TODO: NHS app can land here. So we may need to request Tenant & patient details from the backend.
  // ?from=nhsApp
  {
    path: 'admin-problem-details',
    name: 'admin-problem-details',
    component: ProblemDetailsView,
    meta: {
      ...defaultMetaMedicalRequest,
      formConfig: formAdminRequestDetails,
      requiresValidPatient: true,
      pageTitle: 'Request details',
      layoutPageTitle: 'Request details',
    },
  },
  {
    path: 'summary',
    name: 'admin-summary',
    component: SummaryView,
    meta: {
      ...defaultMetaMedicalRequest,
      layoutPageTitle: 'Check your answers',
      requiresValidPatient: true,
    },
  },
  {
    path: 'submitted-successfully',
    name: 'admin-submitted-successfully',
    component: SubmittedSuccessfullyView,
    meta: {
      ...defaultMetaMedicalRequest,
      backButton: false,
      layoutPageTitle: null,
      pageTitle: 'Request submitted successfully',
    },
  },
];

export default adminRequestChildren;
